// Mock data for when Supabase is not configured
export const mockData = {
  services: [
    {
      id: 1,
      title: "Automatización con IA",
      description: "Implementamos soluciones de inteligencia artificial para automatizar procesos empresariales",
      icon: "Bot",
      features: ["Chatbots inteligentes", "Procesamiento de documentos", "Análisis predictivo"],
      created_at: new Date().toISOString()
    },
    {
      id: 2,
      title: "Análisis de Datos",
      description: "Transformamos tus datos en insights accionables para la toma de decisiones",
      icon: "ChartBar",
      features: ["Dashboards interactivos", "Reportes automatizados", "Análisis en tiempo real"],
      created_at: new Date().toISOString()
    },
    {
      id: 3,
      title: "Consultoría Digital",
      description: "Asesoramiento experto para tu transformación digital",
      icon: "Users",
      features: ["Estrategia digital", "Optimización de procesos", "Gestión del cambio"],
      created_at: new Date().toISOString()
    },
    {
      id: 4,
      title: "Desarrollo de Software",
      description: "Creamos soluciones de software personalizadas para tu negocio",
      icon: "Code",
      features: ["Aplicaciones web", "Aplicaciones móviles", "Integraciones API"],
      created_at: new Date().toISOString()
    }
  ],
  testimonials: [
    {
      id: 1,
      name: "María González",
      company: "Tech Solutions Inc.",
      role: "CEO",
      content: "Neurolytics transformó completamente nuestra forma de trabajar. La automatización implementada nos ha ahorrado cientos de horas.",
      rating: 5,
      created_at: new Date().toISOString()
    },
    {
      id: 2,
      name: "Carlos Rodríguez",
      company: "Innovate Corp",
      role: "CTO",
      content: "El equipo de Neurolytics demostró un profundo conocimiento técnico y entregó resultados excepcionales.",
      rating: 5,
      created_at: new Date().toISOString()
    },
    {
      id: 3,
      name: "Ana Martínez",
      company: "Digital Ventures",
      role: "Director de Operaciones",
      content: "Los dashboards y análisis que implementaron nos dan una visibilidad sin precedentes de nuestro negocio.",
      rating: 5,
      created_at: new Date().toISOString()
    }
  ],
  faqs: [
    {
      id: 1,
      question: "¿Qué servicios ofrece Neurolytics?",
      answer: "Ofrecemos automatización con IA, análisis de datos, consultoría digital y desarrollo de software personalizado.",
      category: "general",
      created_at: new Date().toISOString()
    },
    {
      id: 2,
      question: "¿Cuánto tiempo toma implementar una solución?",
      answer: "El tiempo varía según la complejidad del proyecto. Típicamente, los proyectos van desde 2 semanas hasta 6 meses.",
      category: "proceso",
      created_at: new Date().toISOString()
    },
    {
      id: 3,
      question: "¿Ofrecen soporte post-implementación?",
      answer: "Sí, todos nuestros servicios incluyen soporte continuo y mantenimiento según el plan elegido.",
      category: "soporte",
      created_at: new Date().toISOString()
    },
    {
      id: 4,
      question: "¿Trabajan con empresas pequeñas?",
      answer: "Absolutamente. Trabajamos con empresas de todos los tamaños, desde startups hasta corporaciones.",
      category: "general",
      created_at: new Date().toISOString()
    }
  ],
  statistics: [
    {
      id: 1,
      label: "Clientes Satisfechos",
      value: "150+",
      icon: "Users",
      created_at: new Date().toISOString()
    },
    {
      id: 2,
      label: "Proyectos Completados",
      value: "300+",
      icon: "Briefcase",
      created_at: new Date().toISOString()
    },
    {
      id: 3,
      label: "Horas Ahorradas",
      value: "50,000+",
      icon: "Clock",
      created_at: new Date().toISOString()
    },
    {
      id: 4,
      label: "ROI Promedio",
      value: "320%",
      icon: "TrendingUp",
      created_at: new Date().toISOString()
    }
  ]
};